<template>
  <div>
    <!-- + -->
    <svg
      v-if="!open"
      style="width: 24px; height: 24px; color: #cccccc"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    </svg>
    <!-- × -->
    <svg
      v-if="open"
      style="width: 24px; height: 24px; color: #cccccc"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'DisplaySwitchButton',
  props: {
    open: { default: false }
  }
}
</script>
